import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { SendingDomainsComponent } from 'app/components/sending-domains/SendingDomainsComponent'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useUser } from 'app/utils'

// Sending Domains (TRK-6052) — workspace-level. Gated on settings:workspace;
// supers always pass (the permission check short-circuits for super users).
// observer: reads authStore.user in render, which resolves asynchronously.
const SendingDomains = observer(function SendingDomains() {
  const user = useUser()
  const checkPermission = useCheckPermission()

  if (!user) return <></>
  if (!user.workspaceId) return <Navigate to="/" replace />
  if (!checkPermission(`settings:workspace`)) {
    return <Navigate to={`/settings/users/${user.id}`} replace />
  }

  return <SendingDomainsComponent />
})

export default SendingDomains
